import { combineReducers } from 'redux';

import customerReducer from 'redux/reducers/customerReducer';
import subscriptionReducer from 'redux/reducers/subscriptionReducer';
import threeDSReducer from 'redux/reducers/3dsReducer';
import globalReducer from './globalReducer';
import checkoutReducer from './checkoutReducer';
import cardTokenizationReducer from './cardTokenizationReducer';
import beneficiaryTokenizationReducer from './beneficiaryTokenizationReducer';
import cardIssuingDetailsReducer from './issuing/detailsReducer';
import cardIssuingActivateReducer from './issuing/activateReducer';
import idvReducer from './idvReducer';
import cardFormReducer from './cardFormReducer';
import paymentSettingsReducer from './paymentSettingsReducer';
import digitalWalletProvidersReducer from './digitalWalletProvidersReducer';
import otpReducer from './otpReducer';
import reusableLinkReducer from './reusableLink';
import shortlinkReducer from './shortlink';
import formReducer from './formReducer';
import PayoutTrackerReducer from './payoutTrackerReducer';
import demoReducer from './demo';

const reducers = combineReducers({
  global: globalReducer,
  checkout: checkoutReducer,
  cardTokenization: cardTokenizationReducer,
  beneficiaryTokenization: beneficiaryTokenizationReducer,
  issuing: cardIssuingDetailsReducer,
  cardIssuingActivate: cardIssuingActivateReducer,
  idv: idvReducer,
  subscription: subscriptionReducer,
  cardForm: cardFormReducer,
  paymentSettings: paymentSettingsReducer,
  threeDS: threeDSReducer,
  digitalWalletProviders: digitalWalletProvidersReducer,
  otp: otpReducer,
  customer: customerReducer,
  reusableLink: reusableLinkReducer,
  shortlink: shortlinkReducer,
  form: formReducer,
  payoutTracker: PayoutTrackerReducer,
  demo: demoReducer
});

export default reducers;
